export const BASE_API_URL = process.env.NEXT_PUBLIC_BASE_API_URL?.replace(/\s/g, '') ?? ''

export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN?.replace(/\s/g, '') ?? ''

export const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV?.replace(/\s/g, '') ?? ''

export const GOOGLE_ANALYTICS_ID =
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID?.replace(/\s/g, '') ?? ''

export const HJID = process.env.NEXT_PUBLIC_HJID?.replace(/\s/g, '') ?? ''

export const HJSV = process.env.NEXT_PUBLIC_HJSV?.replace(/\s/g, '') ?? ''

export const PENALTY_SHOOTOUT_GAME_URL =
  process.env.NEXT_PUBLIC_PENALTY_SHOOTOUT_GAME_URL?.replace(/\s/g, '') ??
  'https://dalby7-penalty-shootout.low6.com/'

type Env = 'DEV' | 'STAGING' | 'PRODUCTION'

export const getCorrectFEUrl = (env: Env) => {
  const envMap = {
    DEV: 'dev.',
    STAGING: 'stage.',
    PRODUCTION: '',
  }
  return `https://partner.${envMap[env]}playhunch.com`
}

export const WEBSITE_URL = getCorrectFEUrl(APP_ENV as Env)
